import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'

import BusinessSection from '@/business-section'
import SectionContactForm from '@/section-contact-form'

import './styles.css'

const SectionCasting = ({ data, gray }) => (
  <BusinessSection
    gray={gray}
    title="Casting Tools"
    subtitle="Better results in less time"
    topText="Next Level"
  >
    <div className="flex items-center justify-between mb6">
      <div className="w-22 mw184">
        <Img sizes={data.castingImg1.sizes} alt="Casting Tools" />
      </div>
      <div className="w-56">
        <Img sizes={data.castingImg2.sizes} alt="Casting Tools" />
      </div>
      <div className="w-22 mw184">
        <Img sizes={data.castingImg3.sizes} alt="Casting Tools" />
      </div>
    </div>

    <div className="mw460 w-100 center">
      <p className="mb3 tc">Contact us for premium partnership</p>
      <SectionContactForm justEmail />
    </div>
  </BusinessSection>
)

SectionCasting.propTypes = {
  data: PropTypes.object,
  gray: PropTypes.bool
}

export default SectionCasting



// WEBPACK FOOTER //
// ./src/components/section-casting/section-casting.js